
  /**
   * @license
   * author: epignosis front-end team
   * @epignosis_llc/gnosis.js v6.0.0
   * Released under the MIT license.
   */

import { r as reactIs } from '../../_virtual/index5.js';
import './cjs/react-is.production.min.js';
import './cjs/react-is.development.js';
import { __exports as reactIs_production_min } from '../../_virtual/react-is.production.min.js';
import { __exports as reactIs_development } from '../../_virtual/react-is.development.js';

if (process.env.NODE_ENV === 'production') {
  reactIs.exports = reactIs_production_min;
} else {
  reactIs.exports = reactIs_development;
}
//# sourceMappingURL=index.js.map
